export default {
  type: "establishment-transfer-items",
  storable: {
    type: "products",
    id: null,
  },
  unitOfMeasureUnit: {
    type: "unit-of-measure-units",
    id: null,
  },
  relationshipNames: [
    "unitOfMeasureUnit",
    "storable",
    "transfer",
  ],
  quantity: 1,
};
